export const NoteIcon = ({ color = 'currentColor', height = '16px', width = '16px', style = {}})=>{
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={width}
        fill={color}
        style={style}
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 
               8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 
               2zm.75-6.25a.75.75 0 00-1.5 0v3.5a.75.75 0 001.5 
                0v-3.5z"
          clipRule="evenodd"
        />
      </svg>)
}